"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[17151],{

/***/ 17151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var PaginationPrevIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        viewBox: "0 0 9 13",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Page-1",
            stroke: "none",
            strokeWidth: "1",
            fill: "currentColor",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "Apple-TV-Copy-5",
                transform: "translate(-714.000000, -3166.000000)",
                fill: "currentColor",
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    id: "Group-7",
                    transform: "translate(696.000000, 3149.000000)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        id: "down-chevron-copy-4",
                        transform: "translate(22.660000, 23.644000) rotate(-270.000000) translate(-22.660000, -23.644000) translate(16.516000, 19.847536)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                            id: "Path",
                            points: "10.8390244 -5.96188678e-13 6.14400024 4.69502419 1.44897606 -5.96188678e-13 0 1.44892806 6.14400024 7.5929283 12.2880005 1.44892806"
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PaginationPrevIcon);


/***/ })

}]);